var map = {
	"./mi_blockframes.jpg": 6049,
	"./mi_journey_map_kasia.png": 249,
	"./mi_journey_map_ted.png": 7458,
	"./mi_mobile_1.png": 5011,
	"./mi_mobile_2.png": 4146,
	"./mi_mobile_3.png": 2316,
	"./mi_persona_kasia.png": 3403,
	"./mi_persona_ted.png": 5441,
	"./mi_wireframes_1.jpg": 7146,
	"./mi_wireframes_2.jpg": 2632,
	"./navigation_architecture.png": 8474,
	"./user_flow_create_private_section.png": 2886,
	"./user_flow_invite_members_and_change_time_zone.png": 779,
	"./user_flow_register.png": 8649,
	"./user_flow_track_hours.png": 6681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7892;